export default "__VITE_ASSET__DMjhLqHC__"